const STORAGE_KEY = 'personnelManagementFilterState';

export interface PersonnelFilterState {
  searchText: string;
  selectedDepartment: string;
  currentPage: number;
  pageSize: number;
}

/**
 * Lưu filter state vào localStorage
 */
export const savePersonnelFilterState = (state: PersonnelFilterState): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('Error saving personnel filter state:', error);
  }
};

/**
 * Lấy filter state từ localStorage
 */
export const getPersonnelFilterState = (): PersonnelFilterState | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as PersonnelFilterState;
    }
  } catch (error) {
    console.error('Error getting personnel filter state:', error);
  }
  return null;
};

/**
 * Xóa filter state khỏi localStorage
 */
export const clearPersonnelFilterState = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing personnel filter state:', error);
  }
};


